import React from "react";
import "../../../styles/DefenceStyles/DefenceProduct.css"
// Import all four sections from same folder
import GpsFanOutUnit from "./GpsFanOutUnit";
import FlashingKit from "./FlashingKit";
import BreakOutBox from "./BreakOutBox";
import DefenceApplications from "./DefenceApplications";

const DefenceProducts = () => {
  return (
    <main className="defence-products-page">
      
      {/* SECTION 1 */}
      <GpsFanOutUnit />

      {/* SECTION 3 */}
      <BreakOutBox />

      {/* SECTION 2 */}
      <FlashingKit />

      {/* SECTION 4 */}
      <DefenceApplications />

    </main>
  );
};

export default DefenceProducts;
